import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "trim" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-block card-body" }
const _hoisted_5 = { class: "fz-5 mt-2" }
const _hoisted_6 = { class: "fz-5 mb-2" }
const _hoisted_7 = { class: "fz-5 my-2" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-download" }, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "d-flex mt-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cube" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-uncharted" }, null, -1)

import { translation } from "../../../../lang/Translation";
import { SketchFabResult } from "../model/SketchFabResult";
import { ref } from "vue";
import { DialogHandler } from "../../DialogHandler";
import { GlobalImport } from "../../../../utils/GlobalImport";
import { blocklyStore } from "../../../../blockly/blocklyStore";
import { MessageDialog } from "../../../../../framework/frontend/MessageDialog";
import { glTFModelElement } from "../../../../blockly/elements/glTFModelElement";
import { BlockFactory } from "../../../../blockly/BlockFactory";
import axios from "axios";
import { SessionMemory } from "../../../../utils/SessionMemory";
import Loading from "../../../common/LoadingView.vue";
interface Prop {
  asset: SketchFabResult;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SketchFabCardSection',
  props: {
    asset: null
  },
  setup(__props: any) {

const props = __props as {
  asset: SketchFabResult;
};


const t = translation;
const authorTitle = t.to("作者", "sf_author");
const searchTitle = t.to("タイトル", "sf_title");
const access_code = ref(SessionMemory.instance.skechFabAuthCode);
const loading = ref(false);

/**
 * SkechFabのモデルを取り出す
 */
const getSketchFabModel = async (asset) => {
  const uid = asset.uid;
  // Common.startLoading(uid, true, 'ロード中...モデルによっては1−2分かかることがあります。画面が切り替わるまでそのままお待ちください');
  const url = "/v1/scketchfab/download";
  const data = { uid: uid, access_code: access_code.value };
  let result;
  try {
    loading.value = true;
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    result = response.data;
  } catch (e) {
    MessageDialog.systemError(
      t.to(`ScketchFabデータ取得`, "sf_get_data_error"),
      `${asset.id}`,
      e
    );
    return;
  } finally {
    loading.value = false;
  }

  // console.log("result", result);
  // glTFブロックを作成
  const glTFBlock = new glTFModelElement();
  glTFBlock.addDefaultKeyValue("src", result.url);
  glTFBlock.addDefaultKeyValue("nameField", asset.name);
  glTFBlock.addDefaultKeyValue("thumbnailField", result.url);
  // glTFBlock.setNextStatement(enText);

  // WorkSpaceが読み込まれた時にXMLを適用する
  // XMLを生成
  const selected_xml = glTFBlock.toXml();
  const Blockly = GlobalImport.getBlockly();
  Blockly.Xml.domToBlock(blocklyStore.workspace, selected_xml, true);
  DialogHandler.hideDialog(DialogHandler.sketchFabListDialogId);
};

// ダウンロードリクエスト済み
const isDownloadRequested = ref(false);

// ダウンロードをリクエストする処理（サーバーサイド未実装）
const requestDownload = async (asset) => {
  const uid = asset.uid;
  // Common.startLoading(uid, true, 'ロード中...モデルによっては1−2分かかることがあります。画面が切り替わるまでそのままお待ちください');
  const url = "/v1/scketchfab/download";
  const data = { uid: uid, access_code: access_code.value };

  try {
    loading.value = true;
    const response = await axios.post(url, data, {
      headers: { "Content-Type": "application/json" },
    });
    isDownloadRequested.value = true;
  } catch (e) {
    MessageDialog.systemError(
      t.to(`ScketchFabデータ取得`, "sf_get_data_error"),
      `${asset.id}`,
      e
    );
    return;
  } finally {
    loading.value = false;
  }
};

const getModelViewer = async (asset) => {
  const uid = asset.uid;
  // Common.startLoading(uid, true, 'ロード中...モデルによっては1−2分かかることがあります。画面が切り替わるまでそのままお待ちください');
  const url = "/v1/scketchfab/download";
  const data = { uid: uid, access_code: access_code.value };
  const response = await axios.post(url, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  const result = response.data;
  // console.log("result", result);

  const factory = new BlockFactory();
  const selected_xml = factory.getModelViewerSimpleModel(result.url);
  // factory.addWorkspaceAfterMounted(gltf);

  MessageDialog.info(
    t.to(
      "平面検知ARモデルブロックを追加しました。平面検知ARはシーンスタートを置かずに単独で実行してください。",
      "sf_model_viewer_attention"
    )
  );
  const Blockly = GlobalImport.getBlockly();
  Blockly.Xml.domToBlock(blocklyStore.workspace, selected_xml, true);
  DialogHandler.hideDialog(DialogHandler.sketchFabListDialogId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "card-img-top img-responsive w-100",
        style: {"height":"15rem","object-fit":"cover"},
        src: __props.asset.thumbnails.images[0].url,
        onerror: "this.src='../public/list_back_noimage.png'",
        lazyload: ""
      }, null, 8, _hoisted_3)
    ]),
    (loading.value)
      ? (_openBlock(), _createBlock(Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(searchTitle)) + ":", 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.asset.name), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(authorTitle)) + "：" + _toDisplayString(__props.asset.user.username), 1),
      (!isDownloadRequested.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn btn-primary w-100",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (requestDownload(__props.asset)))
            }, [
              _createTextVNode(_toDisplayString(_unref(t).to("ダウンロードをリクエスト", "sf_request_download")), 1),
              _hoisted_9
            ])
          ]))
        : _createCommentVNode("", true),
      (isDownloadRequested.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-primary w-50 me-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (getSketchFabModel(__props.asset)))
            }, [
              _createTextVNode(_toDisplayString(_unref(t).to("3Dモデル", "sf_3dmodel")), 1),
              _hoisted_11
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary w-50",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (getModelViewer(__props.asset)))
            }, [
              _createTextVNode(_toDisplayString(_unref(t).to("平面検知AR", "sf_model_viewer")), 1),
              _hoisted_12
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})